import { Amount, Flag } from "@george-labs.com/design-system"

export const IMAGE_SIZE = "144px"

const FLAG_HUN_PATH = "./assets/flag_hun.png"

interface IOfferAmountComponentProps {
  amount: number
}

const OfferAmountComponent: React.FC<IOfferAmountComponentProps> = ({
  amount,
}) => {
  return (
    <Amount
      isAppendedCurrency
      value={amount}
      precision={0}
      appendedText="Ft"
      thousandSeparator=" "
    />
  )
}

const OfferFlag = () => (
  <>
    <Flag alt="HUN flag" imageUrl={FLAG_HUN_PATH} /> HUF
  </>
)

export { OfferAmountComponent, OfferFlag }
